const tw = {
  login: '登入',
  logout: '登出',
  hello: '你好',
  setting: '設定',
  back: '返回',
  startPage: {
    personFile: '個人檔案',
    scan: '掃描',
    startToScan: '開始掃描',
    startTip: '請掃瞄票卷或是洽服務人員開啟導覽服務',
  },
  settingPage: {
    privacyTerm: '隱私權條款',
    serviceTerm: '服務條款',
  },
  scanPage: {
    scanTitie: '請掃瞄票卷開啟導覽服務',
    NotAllowedError: '你必須開啟相機訪問權限',
    NotFoundError: '這台裝置並沒有相機功能',
    NotSupportedError: '因為安全性的需求，必須在HTTPS才能使用',
    NotReadableError: '相機已被使用，請關閉其他應用程式後再重新嘗試',
    OverconstrainedError: '無法使用相機',
    StreamApiNotSupportedError: '瀏覽器版本過老，請更新瀏覽器版本',
    scanError: '掃描發生錯誤，請洽工作人員',
  },
  loginPage: {
    title: '數位音訊導覽服務',
    fbBtn: '使用Facebook登入',
    googleBtn: '使用Google登入',
    phoneBtn: '使用手機簡訊登入',
    loginTip: '請注意：請務必打開瀏覽器彈跳視窗選項，以便完成Gmail或簡訊登入，需登入完成才可使用此數位音訊導覽體驗，感謝您的配合。',
    submit: '送出',
    textCodeInput: '請輸入簡訊驗證碼',
    loginFailed: '登入失敗',
    SMSValidFailed: '驗證碼錯誤，請重新登入。',
    sendSMSFailed: '簡訊發送失敗，請稍後再試。',
    borwserFailed: '請使用chrome瀏覽器開啟，才能完整體驗此應用',
    GPSBrowserFailed: '該瀏覽器無法使用地理位置定位服務，請嘗試其他瀏覽器。',
    GPS_ERROR_PERMISSION_DENIED: '您已拒絕對獲取地理位置的請求，將無法使用本服務。\n請開啟地理位置定位服務權限，再重新整理網頁。',
    GPS_ERROR_POSITION_UNAVAILABLE: '位置信息是不可用的。',
    GPS_ERROR_TIMEOUT: '請求使用者地理位置定位服務超時',
    GPS_ERROR_UNKNOWN_ERROR: '未知錯誤',
    GPS_ERROR_ORTHER: '發生錯誤。',
  },
  registerPage: {
    submit: '送出',
    next: '下一步',
    register: '註冊',
    gender: '性別',
    age: '年齡',
    nickname: '暱稱',
    firstStepTitle: '請填寫基本資料來完成註冊',
    firstStepDescription: '註冊過程只需30秒，請按下一步來繼續',
    failure: '註冊失敗',
    nameIsRequired: '名稱為必填',
    male: '男',
    female: '女',
  },
  profilePage: {
    name: '會員名稱',
    number: '會員編號',
    viewLog: '觀覽紀錄',
  },
  exhibitionPage: {
    startToTour: '開始導覽',
  },
  exhibitionListPage: {
    toggle: '切換',
    numberMode: '數字模式',
    listMode: '列表模式',
    title: '作品名稱',
    errorTip: '尚無展覽資訊，請洽工作人員',
    exhibitionCode: '展覽編號',
    inputTip: '請輸入導覽編號',
    cofirm: '確定',
    imgAlt: '表演的圖',
    notFound: '查無此代碼',
  },
  cookies: {
    title: 'Cookies使用說明',
    description: '為改善本網站的瀏覽體驗，我們會使用第一方及第三方的Cookie。請了解我們的',
    cookiesLink: 'Cookies使用說明',
    privacyLink: '使用者及隱私權說明',
    and: '與',
    close: '關閉',
  },
  errorPage: {
    title: '無法瀏覽此頁面',
    lead: '此連結可能損壞，或是該網頁已被移除。請確認你要打開的連結是否正確。',
    contactUs: '聯絡我們：',
  },
}

export default tw
